import React from 'react';
import TopBar from '../../../components/template/TopBar/TopBar';
import ASSET_PATHS from '../../../assets/config/assetPaths';

const Settings: React.FC = () => {
    const handleOptionClick = (option: string) => {
        console.log(`${option} clicked`);
    };

    return (
        <div className="min-h-screen flex flex-col bg-gray-100">
            <TopBar title="Settings" showBackIcon={true} />
            <div className=" w-full p-4">
                <div className="bg-white rounded-lg w-full">

                    <div className="text-textPrimary text-md">
                        {/* <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke Debug History')}>
                            <span>Nuke Debug History</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />

                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke Local Work Orders')}>
                            <span>Nuke Local Work Orders</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />
                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Nuke All Media')}>
                            <span>Nuke All Media</span>
                            <img src={ASSET_PATHS.nuke} alt="Progress" />
                        </div> */}

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Console Current Media')}>
                            <span>Console Current Media</span>
                            <img src={ASSET_PATHS.media} alt="Progress" />
                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Console Media Queue')}>
                            <span>Console Media Queue</span>
                            <img src={ASSET_PATHS.media} alt="Progress" />
                        </div>

                        <div className="flex border-t items-center justify-between cursor-pointer p-3 " onClick={() => handleOptionClick('Console Inspector Templates DB')}>
                            <span>Console Inspector Templates DB</span>
                            <img src={ASSET_PATHS.download} alt="Progress" />
                        </div>
                    </div>

                    <div className="border-t p-3">
                        <div className="flex items-center justify-between cursor-pointer text-primary" onClick={() => handleOptionClick('Clear Cache')}>
                            <span>Clear Cache</span>
                            <span className='text-textPrimary mr-2'>0</span>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default Settings;
